/**
 * @prettier
 */

// Shared "submission completed" side-effects.
//
// Both `SuccessPage` and the `finalizeThenSuccess` -> return_url redirect
// path need to:
//   - mark the submission complete in storage (so a fresh load won't
//     re-use the same uuid/session — see `isSubmissionComplete` checks)
//   - emit the DataDog completion log and flush it via the "freeze" event
//   - clear all user PII from storage
//   - notify any iframe parent that hosts us via postMessage
//
// Keeping these in one place prevents the redirect path from silently
// drifting away from SuccessPage's behaviour.

import DataDogService from "./datadogService";
import { areCookiesEnabled } from "./helpers";
import selectStorage from "./selectStorage";
import { sendSuccessMessage } from "../../state/actions/messageActions";

const PII_STORAGE_KEYS = [
    "uuid",
    "sessionid",
    "submissionid",
    "region",
    "disableheader",
    "passive_liveness_enabled",
    "target",
    "handoff_session",
];

export function markSubmissionComplete() {
    selectStorage(areCookiesEnabled()).setItem("submission_complete", true);
}

export function clearUserPII() {
    const storage = selectStorage(areCookiesEnabled());
    PII_STORAGE_KEYS.forEach(key => storage.removeItem(key));
}

// Runs every side-effect SuccessPage performs on mount, in the same order,
// so callers that bypass the success page (e.g. external return_url redirect)
// remain behaviourally equivalent.
export function runSubmissionCompletionSideEffects() {
    markSubmissionComplete();
    DataDogService.log("Submission Completed");
    // Workaround to manually flush DataDog logs before navigation.
    document.dispatchEvent(new Event("freeze"));
    clearUserPII();
    sendSuccessMessage("*");
}
